import React from "react";

const DietitianAvatar = ({ dietitianImage }) => {
  return (
    <div
      className="single-dietitian relative -ml-[10%] w-14 h-14 first:ml-0 transition-all duration-300 hover:-translate-y-1 hover:z-10 hover:before:content-[attr(data-tooltip)] before:absolute before:bottom-[107%] before:shadow-md before:left-1/2 before:-translate-x-1/2 before:bg-white before:px-[10px] before:py-[9px] before:truncate before:invisible hover:before:visible before:rounded before:text-[10px] before:text-[#a0a0a0] hover:after:content-[''] after:border-4 after:border-transparent after:border-t-white after:absolute after:bottom-[94%] after:left-1/2 after:-translate-x-1/2 after:hidden hover:after:block"
      data-tooltip={"Nasser Saleh"}
    >
      <img
        src={dietitianImage}
        alt=""
        className="h-auto w-full rounded-full object-scale-down"
      />
    </div>
  );
};

export default DietitianAvatar;
